/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots, OverflowItem } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingCommandBarTabSlots, GroundingCommandBarTabState } from './GroundingCommandBarTab.types';

/**
 * Render the final JSX of GroundingCommandBarTab
 */
export const renderGroundingCommandBarTab_unstable = (state: GroundingCommandBarTabState): JSXElement => {
  assertSlots<GroundingCommandBarTabSlots>(state);

  return (
    <OverflowItem id={state.value} priority={state.selected ? 2 : 1}>
      <state.root>
        <state.tab />
      </state.root>
    </OverflowItem>
  );
};
